import type { NavMenuRouter } from 'Storybook/core/Menu/Menu.types';
import ROUTES from 'Utilities/routes';

export const marketplaceActiveStateCallback = ({ pathname, query }: NavMenuRouter): boolean =>
	pathname === ROUTES.SIGN_IN.href && query?.redirect === ROUTES.VEHICLE_LIST.as();
export const signInActiveStateCallback = ({ pathname, query }: NavMenuRouter): boolean =>
	pathname === ROUTES.SIGN_IN.href && query?.redirect !== ROUTES.VEHICLE_LIST.as();
export const howItWorksActiveStateCallback = ({ pathname }: NavMenuRouter): boolean =>
	pathname === ROUTES.HOW_IT_WORKS.href;
